import { memo } from 'react';
import jmespath from 'jmespath';

export type Rule = {
  path?: string;
  style: React.CSSProperties;
};

const getStyleObject = (data: unknown, rules: Rule[]): React.CSSProperties => {
  return rules.reduce((styles, { path, style }) => {
    const isStyleApplicable = !path || jmespath.search(data, path);
    return isStyleApplicable ? { ...styles, ...style } : styles;
  }, {});
};

type Props = React.HTMLAttributes<HTMLDivElement> & {
  data: unknown;
  rules: Rule[];
};

export const InlineStyle = memo(
  ({ data, rules, children, ...props }: Props) => {
    return (
      <div style={getStyleObject(data, rules)} {...props}>
        {children}
      </div>
    );
  }
);
